var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { Suspense } from 'react';
import { Header } from '@at/design-system-collections';
const LazyATSlideSignInComponent = React.lazy(() => import(
/* webpackChunkName: "LazyATSlideSignInComponent" */
'@at/connected-signin').then((module) => ({ default: module.ATSlideSignInComponent })));
export const HeaderPresentational = (_a) => {
    var { environment, showSignInModal, afterSignInUrl, afterSignInCallback } = _a, props = __rest(_a, ["environment", "showSignInModal", "afterSignInUrl", "afterSignInCallback"]);
    return (_jsx(Header, Object.assign({}, props, { env: environment, children: showSignInModal && (_jsx(Suspense, { fallback: "", children: _jsx(LazyATSlideSignInComponent, { showing: showSignInModal, setShowing: props.setShowSignInModal, afterSigninUrl: afterSignInUrl, afterSignInCallback: afterSignInCallback }) })) })));
};
